<template>

  <el-select
    v-model="currentValue"
    :disabled="disabled"
    :placeholder="title"
    :remote-method="fetchData"
    size="small"
    filterable
    remote
    reserve-keyword
    clearable
    automatic-dropdown
    class="filter-item"
    @change="handlerChange"
    @clear="fetchData('')"
    style="width: 200px"
  >
    <el-option
      v-for="item in dataList"
      :key="item.value"
      :label="item.title"
      :value="item.value"
    />
  </el-select>


   <!-- <el-select v-model="currentValue" :placeholder="title" @change="handlerChange" clearable>
     <el-option
      v-for="item in dataList"
      :key="item.value"
      :label="item.title"
      :value="item.value"
    />
    </el-select> -->


</template>

<script>

import { fetchTree } from '@/api/examMan/sys/dict/value'

export default {
  name: 'DicListSelect',
  props: {
    dicCode: String,
    title: String,
    value: {
      type: String | Number
    },
    disabled: Boolean,
    excludes: Array
  },
  data() {
    return {
      // 下拉选项值
      dataList: [],
      currentValue: []
    }
  },

  watch: {
    // 检测查询变化
    value: {
      handler(val) {
        if (val) {
          this.currentValue = this.value + ''
        } else {
          this.currentValue = ''
        }
      }
    },
    dicCode: {
      handler() {
        this.fetchData()
      }
    }
  },
  created() {
    this.currentValue = this.value
    this.fetchData()
  },
  methods: {

    fetchData() {
      fetchTree({ dicCode: this.dicCode, excludes: this.excludes }).then(response => {
        this.dataList = response.data.data
      })
    },
    handlerChange(e) {
      this.$emit('change', e)
      this.$emit('input', e)

      let row = ''
      for (let item of this.dataList) {
        if (item.value == e) {
          row = item
        }
      }
      this.$emit('backFunc', row)
    }
  }
}
</script>

<style scoped>

::v-deep .el-input.el-input--suffix {
  display: flex !important;
  cursor: pointer;
  overflow: hidden;
}
</style>
